'use client';

import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { usePathname } from 'next/navigation';

export interface NavEntity {
  ticker?: string;
  sector?: string;
  sectorSlug?: string;
  pathname?: string;
}

interface NavEntityContextValue {
  entity: NavEntity | null;
  setEntity: (entity: NavEntity | null) => void;
}

const NavEntityContext = createContext<NavEntityContextValue>({ entity: null, setEntity: () => undefined });

export const NavEntityProvider = ({ children }: { children: ReactNode }) => {
  const [entity, setEntity] = useState<NavEntity | null>(null);
  return <NavEntityContext.Provider value={{ entity, setEntity }}>{children}</NavEntityContext.Provider>;
};

export const useNavEntity = (): NavEntity | null => useContext(NavEntityContext).entity;

export const NavEntitySetter = ({ ticker, sector, sectorSlug }: NavEntity) => {
  const { setEntity } = useContext(NavEntityContext);
  const pathname = usePathname();
  useEffect(() => {
    setEntity({ ticker, sector, sectorSlug, pathname });
    return () => setEntity(null);
  }, [setEntity, ticker, sector, sectorSlug, pathname]);
  return null;
};
